import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import UserPanel from "../../components/User/UserPanel";
import Contracts from "../../components/Contracts/Contracts";

export default function UserPage() {
  const { currentUser, isAdmin } = useAuth();
  return (
    <>
      <UserPanel />
      <Contracts />
    </>
  );
}
